<wiz-hgroup width="100%" height="100%" verticalAlign='center' horizontalAlign='center' (click)="doConnect()" style="cursor: pointer;">
  <wiz-image [sourceObservable]="data.iconOrDie" 
  [wizTooltip]="data.trsLabel"
  width="100%" height="100%"  ></wiz-image>
</wiz-hgroup>
